import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { transmitActiveStatus } from 'src/features/deviceSlice';
import { getBusinessInfo } from 'src/features/userSlice';
import { isTransmissionEnabled } from '../utils';

// Tích truyền QCVN 06:2024/BCA: switch tích truyền, lấy thông tin từ tài khoản, ô cam kết
export default function useTransmission(d, formikRef, notifySaved) {
  const dispatch = useDispatch();

  const [isTransmit, setIsTransmit] = useState(
    isTransmissionEnabled(d.status_transmission)
  );
  const [isInfoTransmit, setIsInfoTransmit] = useState(false);
  const [isCommitmentChecked, setIsCommitmentChecked] = useState(false);

  const reset = () => {
    setIsTransmit(isTransmissionEnabled(d.status_transmission));
    setIsInfoTransmit(false);
    setIsCommitmentChecked(false);
  };

  const isInfoTransmitMounted = useRef(false);

  useEffect(() => {
    reset();
    isInfoTransmitMounted.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [d.id]);

  // Bật "Lấy thông tin từ tài khoản" -> điền thông tin doanh nghiệp của thiết bị, tắt -> xoá trắng
  useEffect(() => {
    if (!formikRef.current) return;

    if (!isInfoTransmitMounted.current) {
      isInfoTransmitMounted.current = true;
      return;
    }

    formikRef.current.setValues(prev => ({
      ...prev,
      business_name: isInfoTransmit ? d.transport_operator : '',
      tax_code: isInfoTransmit ? d.tax_code : '',
      business_id: isInfoTransmit ? d.business_id : ''
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInfoTransmit]);

  const onToggleTransmit = event => {
    const status = event.target.checked ? 1 : 0;
    if (status === 1 && d.end_user_phone) {
      dispatch(getBusinessInfo({ phone: d.end_user_phone }));
    }
    dispatch(transmitActiveStatus({ id: d.id, data: { status } }));
    setIsTransmit(event.target.checked);
    notifySaved();
  };

  return {
    isTransmit,
    isInfoTransmit,
    isCommitmentChecked,
    setIsCommitmentChecked,
    onToggleTransmit,
    onToggleInfoTransmit: e => setIsInfoTransmit(e.target.checked),
    reset
  };
}
